import "../../AppCalculadoraJS.css"
import "./Display.css";

const Display = ({ valueMain, valueHistory }) => {
    return (
      <div className="display">
        <div className="displayHistory" id="history" data-testid="display-history">
          {valueHistory}
        </div>
        <div className="displayMain" id="display" data-testid="display-main">
          {valueMain}
        </div>
      </div>
    );
}

export default Display;